// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CampaignOutline from '../_raw/ui/icon_campaign_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CampaignOutline);
